import React, { useEffect, useRef, useState } from 'react';
import { Layout } from 'antd';
import CourseStructure from './structure';
import './style.scss';
import PageHeader from '../../components/page-header/PageHeader';
import { useLocation, useNavigate } from 'react-router-dom';

const indexDB = require('idbcache').default;

function PreviewQuiz() {
const backAnchorRef = useRef<HTMLAnchorElement>(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const unitId = searchParams.get('unitId');
  const [title, setTitle] = useState('');
  const [backUrl, setBackUrl] = useState('');
  const [backBreadCrumb, setBackBreadCrumb] = useState('');

  const navigate = useNavigate();
  const navigateBack = () => {
    navigate(backUrl, {
      state: {
        id: unitId
      }
    });
  };

  const { Content } = Layout;
  const imgPath = '/images/';

  const listBreadcrumb = [
    {
      title: (
        <a ref={backAnchorRef} onClick={navigateBack} href={`${backUrl}`}>
          {backBreadCrumb}
        </a>
      ),
    },
    {
      title: title || '',
    },
  ];


  useEffect(() => {
    indexDB.get('current-course').then((val: any) => {
      setTitle(JSON.parse(val).name);
      setBackUrl(JSON.parse(val).backUrl);
      setBackBreadCrumb(JSON.parse(val).backBreadCrumb);

    });
  }, []);

  return (
    <Content>
      <PageHeader
        title={title || ''}
        listBreadcrumb={listBreadcrumb}
        arrowLeft={imgPath + 'arrowLeft.svg'}
        positionItem='column'
        breadcrumb={true}
        headerGroupButton={true}
      />

      <div className='content-layout'>
        <div className='practice-layout'>
          <CourseStructure />
        </div>
      </div>
    </Content>
  );
}

export default PreviewQuiz;
